import { Typography } from 'antd'
import { displayChatTitle, formatChatDate } from './chatHistoryModel'

const { Text } = Typography

type Props = {
  sessionId: string
  title: string | null
  startedAt: string
  onClick: (sessionId: string) => void
}

const ChatHistoryListItem = ({ sessionId, title, startedAt, onClick }: Props) => {
  return (
    <div
      className="chat-history-item"
      onClick={() => onClick(sessionId)}
      style={{ cursor: 'pointer' }}
    >
      <Text strong className="chat-history-item-title">{displayChatTitle(title)}</Text>
      <Text type="secondary" className="chat-history-item-date">
        {formatChatDate(startedAt)}
      </Text>
    </div>
  )
}

export default ChatHistoryListItem
